import AdvertenciaSVG from "./svg/WarningSVG";
import SuggestionSVG from "./svg/SuggestionSVG";
import SuccessSVG from "./svg/SuccessSVG";

export const typesIcon = {
    warning: <AdvertenciaSVG />,
    success: <SuccessSVG/>,
    suggestion: <SuggestionSVG />,
}